<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <h2 class="mt-lg-4" style="font-family: OpenSans-bold; margin-bottom: -10px;">
      <strong>{{TitleHeader}}</strong>
    </h2>
    <!--Section: Horizontal stepper-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Card image-->
        <div
          class="price white-text rounded-top"
          v-bind:style="{padding: '1rem 2rem', textAlign: 'left', background: '#026ab4', fontFamily: 'OpenSans-Regular', fontSize: '16px', lineHeight: '1.38'}"
        >
          <span>
            <img
              alt="icono nuevo fraccionamiento"
              src="https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Contratistas_Icon@3x.png"
              class="img-fluid"
              style="width: 28px; height: 26px"
            />
          </span>
          &nbsp; {{TitleHeader}}
        </div>
        <!--/Card image-->
        <!--Card content-->
        <mdb-card-body>
          <form id="form2" class="needs-validation" novalidate @submit="checkFormfracs">
            <mdb-row class="form-row">
              <!--Form content-->
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro">Datos del registro</p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="firtsName"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Nombre del fraccionamiento</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="firstName"
                        required
                        placeholder="Nombre"
                        maxlength="64"
                        v-model="form.name"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Por favor, introduce un nombre</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="cp"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Código postal</label>
                      <input
                        type="text"
                        required
                        class="form-control text-input"
                        id="cp"
                        placeholder="Código postal"
                        maxlength="5"
                        v-model="form.CodeP"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%"
                        @keyup="getAddressInformation"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Por favor, introduce el código postal</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="city"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Ciudad</label>
                      <input
                        type="text"
                        required
                        class="form-control text-input"
                        id="city"
                        placeholder="Ciudad"
                        maxlength="20"
                        v-model="form.city"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%"
                        disabled
                      />
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="state"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Estado</label>
                      <input
                        type="text"
                        required
                        class="form-control text-input"
                        id="state"
                        placeholder="Estado"
                        maxlength="20"
                        v-model="form.state"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%"
                        disabled
                      />
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold;">Colonia</label>
                      <model-select
                        :options="colonyList"
                        v-model="colonyModel"
                        style="height: 37px;"
                        placeholder="Selecciona una colonia"
                        :isError="colonyValid"
                      ></model-select>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="street"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Calle</label>
                      <input
                        type="text"
                        required
                        class="form-control text-input"
                        id="street"
                        placeholder="Calle"
                        v-model="form.street"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Por favor, introduce una calle</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold;">Número exterior</label>
                      <input
                        type="number"
                        class="form-control text-input"
                        id="number"
                        required
                        placeholder="Número exterior"
                        maxlength="8"
                        v-model="form.numExt"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Por favor, introduce un número exterior</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold;">Número interior</label>
                      <input
                        type="number"
                        class="form-control text-input"
                        id="number"
                        placeholder="Número interior"
                        maxlength="8"
                        v-model="numeroInterior"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold;">Cantidad de licencias</label>
                      <input
                        type="number"
                        class="form-control text-input"
                        id="number"
                        required
                        placeholder="Cantidad de licencias"
                        maxlength="8"
                        v-model="form.licenses"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Por favor, debes asignar un numero de licencias</div>
                    </div>
                  </mdb-col>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        style="font-family: OpenSans-Semibold;"
                      >Administrador de fraccionamiento</label>
                      <model-select
                        :options="adminsList"
                        v-model="adminModel"
                        style="height: 37px;"
                        placeholder="Selecciona un administrador para tu fraccionamiento"
                        :isError="adminValid"
                      ></model-select>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <mdb-row>
                      <div v-if="file_url==''">
                        <div>
                          <mdb-btn type="button" class="btn-Adjuntar btn-file">
                            <mdb-icon icon="paperclip" class="mt-0" />
                            <span style="font-size: 8px">Adjuntar logo</span>
                            <input
                              type="file"
                              accept="image/jpeg, image/png"
                              name="file"
                              id="file"
                              @change="addPhoto"
                            />
                          </mdb-btn>
                        </div>
                      </div>
                      <div v-else>
                        <mdb-row>
                          <div>
                            <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                              <span slot="tip">Eliminar archivo</span>
                              <mdb-btn
                                slot="reference"
                                type="button"
                                rounded
                                size="sm"
                                class="px-2 btn_background"
                                @click="removeFile"
                              >
                                <mdb-icon icon="times" class="mt-0" />
                              </mdb-btn>
                            </mdb-tooltip>
                          </div>
                        </mdb-row>
                        <mdb-row>
                          <div class="embed-responsive" style="width: 22rem;">
                            <img
                              alt="imagen de promocion"
                              :src="file_url"
                              style="display: inline-block; width: 100%"
                            />
                          </div>
                        </mdb-row>
                      </div>
                    </mdb-row>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11"></mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11"></mdb-col>
                </mdb-row>
              </mdb-col>
            </mdb-row>
            <mdb-row class="form-row">
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group"></div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
            </mdb-row>
            <mdb-row style="padding-left: 35%">
              <mdb-col md="2">
                <button
                  type="button"
                  class="waves-effect waves-dark btn btn-next btn-color-prev"
                  @click="remove()"
                >Cancelar</button>
              </mdb-col>
              <mdb-col md="2">
                <mdb-btn
                  type="submit"
                  class="waves-effect waves-dark btn btn-next btn-color-next"
                >{{TextButton}}</mdb-btn>
              </mdb-col>
              <!--Buttons content-->
            </mdb-row>
          </form>
        </mdb-card-body>
        <!--/.Card content-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Horizontal stepper-->
    <!--Modal edit invited -->
  </mdb-container>
</template>
<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import { ModelSelect } from "vue-search-select";
import { mapGetters, mapActions } from "vuex";
import {
  mdbContainer,
  mdbTooltip,
  mdbView,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbInput,
  mdbRow,
  mdbCol,
  mdbTextarea,
  mdbIcon,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";

export default {
  name: "New fracs",
  components: {
    mdbTooltip,
    mdbContainer,
    mdbView,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbInput,
    mdbTextarea,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    ModelSelect
  },
  data() {
    return {
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      TextButton: "Registrar",
      TitleHeader: "Alta fraccionamiento",
      form: {
        name: "",
        numExt: "",
        CodeP: "",
        street: "",
        licenses: "",
        city: "",
        state: ""
      },
      numeroInterior: "",
      colonyList: [],
      colonyModel: {
        value: "",
        uuid: "",
        text: ""
      },
      colonyValid: false,
      adminsList: [],
      adminModel: {
        value: "",
        uuid: "",
        text: ""
      },
      adminValid: false,
      files: null,
      file_url: "",
      communityType: "",
      extensionFile: "",
      idFile: 0,
    }; // END RETURN
  },
  methods: {
    getAddressInformation() {
      if (this.form.CodeP.length == 5) {
        let aux = this;
        Axios.get(Servers.serverApi + "api/addresses/" + aux.form.CodeP, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        })
          .then(function(response) {
            aux.form.state = response.data[0].state;
            aux.form.city = response.data[0].location;
            aux.colonyList = [];
            for (var i = 0; i < response.data.length; i++) {
              var temp = {
                value: response.data[i].idAddress,
                uuid: response.data[i].uuid,
                text: response.data[i].colony
              };
              aux.colonyList.push(temp);
            }
          })
          .catch(function(error) {
            console.log(error.response.data);
          });
      }
    },
    getOnefracs() {
      if (this.isEdit) {
        this.TextButton = "Guardar";
        this.TitleHeader = "Editar fraccionamiento";
        this.form.name = this.fracsValue.name
        this.form.numExt = this.fracsValue.extNumber
        this.form.CodeP = this.fracsValue.address.cp
        this.form.street = this.fracsValue.street
        this.form.licenses = this.fracsValue.licenseTotal
        this.form.city = this.fracsValue.address.city
        this.form.state = this.fracsValue.address.state
        this.numeroInterior = this.fracsValue.intNumber
        this.colonyModel.value = this.fracsValue.address.idAddress
        this.colonyModel.uuid = this.fracsValue.address.uuid
        this.colonyModel.text = this.fracsValue.address.colony
        this.getAddressInformation()
        if(this.fracsValue.user){
          this.adminModel.value = this.fracsValue.user.idUser
          this.adminModel.uuid = this.fracsValue.user.uuid
          this.adminModel.text = this.fracsValue.user.name
        }
        if(this.fracsValue.file){
          this.file_url = this.fracsValue.file.publicUrl
          this.idFile = this.fracsValue.file.idFile
        }

      }
    },
    remove() {
      var obj = [];
      window.location.href = "/fracs";
    },
    cleanForm() {},
    validateForm(form) {
      form.licenses=form.licenses+""
      return (
        Object.keys(form).length ===
        Object.keys(form).filter(key => {return form[key].length > 0}).length
      );
    },
    checkFormfracs(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");
      var valid = this.validateForm(this.form);

      if (this.colonyModel.value) {
        this.colonyValid = false;
      } else {
        this.colonyValid = true;
      }
      if(this.adminModel.value) {
        this.adminValid = false;
      } else {
        this.adminValid = true;
      }
      
      if (!this.colonyValid && valid && !this.adminValid) {
        
        if (this.isEdit) {
          this.putfracs();
        } else {
          this.postfracs();
        }
      }
    },

    putfracs() {
      
      let aux = this;
      var uuid = this.fracsValue.uuid;
      var data = {
         name: aux.form.name,
        cp: aux.form.CodeP ,
        city: aux.form.city,
        state: aux.form.state,
        idAddress: aux.colonyModel.value,
        street: aux.form.street,
        extNumber: aux.form.numExt,
        intNumber: aux.numeroInterior,
        idUser: aux.adminModel.value,
        licenseTotal: aux.form.licenses,
        starDate: "",
        endDate: "",
        idFile: aux.idFile,
        user: {
          idUser: aux.adminModel.value
        }
      };


       if (aux.files) {
        var fileData = {
          uuid: aux.uuidv4(),
          name: aux.uuidv4(),
          extension: aux.extensionFile,
          mimeType: aux.communityType,
          content: aux.files
        };

        data["file"] = fileData;
      }

      Axios.put(Servers.serverApi + "api/fracs/" + uuid, data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.showMessageSucces("fraccionamiento actualizado correctamente", "");
        })
        .catch(error => {
          aux.showMessageError("No se pudo actualizar", "");
          console.log(error.response.data);
        });
    },
    postfracs() {
      let aux = this;
      var data = {
        name: aux.form.name,
        cp: aux.form.CodeP ,
        city: aux.form.city,
        state: aux.form.state,
        idAddress: aux.colonyModel.value,
        street: aux.form.street,
        extNumber: aux.form.numExt,
        intNumber: aux.numeroInterior,
        idUser: aux.adminModel.value,
        licenseTotal: aux.form.licenses,
        starDate: "",
        endDate: "",
        user: {
          idUser: aux.adminModel.value
        }
      };

      if(aux.files){
        data.file={
          uuid: aux.uuidv4(),
          name: aux.uuidv4(),
          extension: aux.extensionFile,
          mimeType: aux.communityType,
          content: aux.files
        }
      }
    
      Axios.post(Servers.serverApi + "api/fracs/admin", data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.showMessageSucces("fraccionamiento  creado correctamente", "");
        })
        .catch(error => {
          aux.showMessageError(
            "No es posible registrar al fraccionamiento",
            error.response.data.error_description
          );
          console.log(error.response.data);
        });
    },
    getUsersIntegrator() {
      let aux = this;

      Axios.get(Servers.serverApi + "api/users/integrator", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.adminsList = [];
          for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].idUser,
              uuid: response.data[i].uuid,
              text: response.data[i].name
            };
            aux.adminsList.push(temp);
          }
        })
        .catch(error => {});
    },
    showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../../../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(text, subtitle) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>" + text + "</span>",
        html: "<span style='font-size: 12px;'>" + subtitle + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {
          this.remove();
        }
      });
    },
    removeFile() {
      this.files = null;
      this.file_url = "";
      this.communityType = "";
      this.extensionFile = "";
      this.idFile = 0;
    },
    addPhoto: function(evt) {
      this.file_url = URL.createObjectURL(evt.target.files[0]);
      this.communityType = evt.target.files[0].type;
      this.extensionFile = evt.target.files[0].name.split(".")[1];
      var img = new Image();
      let aux = this;
      img.src = URL.createObjectURL(evt.target.files[0]);
      img.onload = function() {
        var rdr = new FileReader();
        rdr.onload = function(e) {
          aux.files = e.target.result.split(",")[1];
        };
        rdr.readAsDataURL(evt.target.files[0]);
      };
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
  },
  created() {
    this.getOnefracs();
  },
  mounted() {
    this.getUsersIntegrator();
  },
  watch: {
    colonyModel(newColony) {
      this.colonyModel = newColony;
      if (newColony.value) {
        this.colonyValid = false;
      } else {
        this.colonyModel = true;
      }
    },
    adminModel(newAdmin) {
      this.adminModel = newAdmin
      if(newAdmin.value){
        this.adminValid = false;
      } else {
        this.adminValid = true;
      }
    }
  },
  computed: {
     ...mapGetters({
      isMe:"getWhoAmi",
      isEdit:"getFracEdit",
      fracsValue:"getFrac"
    }),
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.Datos-del-registro {
  width: auto;
  height: 19px;
  font-family: OpenSans-Bold;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.btn.btn-edit {
  padding: 0.2rem 0.4rem;
  font-size: 0.64rem;
  border-radius: 7px;
  width: 24px;
  height: 23p;
}

.form-csv {
  height: 170px;
  width: 300px;
  margin: 0 auto;
  border-radius: 2px;
  border: 1px solid #e8e9ec;
  background-color: #ffffff;
}

.form-csv h5,
.form-csv h6 {
  width: 100%;
  color: #545871;
}

.form-csv input {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100px;
  outline: none;
  opacity: 0;
}

.form-csv input:hover {
  cursor: pointer;
}

.form-csv:hover {
  opacity: 0.7;
  border: 4px dashed #676d6d;
}

.Rectangle-536 {
  width: 190px;
  height: 37px;
  border-radius: 4px;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.Rectngulo-1673 {
  width: 161.6px !important;
  height: 37px !important;
  border-radius: 3px !important;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.Rectngulo-650 {
  width: 1112.7px;
  height: 500.8px;
  border-radius: 25px;
  border: solid 2px #bce0fd;
  background-color: #ffffff;
}

.save-btn {
  font-size: 10px;
  float: right;
}

.text-width {
  width: auto;
}

.text-input {
  width: auto;
}

.btn-next {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-prev {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-final {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-color-next {
  background-color: #23a7ed !important;
  color: #fff !important;
}

.btn-color-prev {
  background-color: #ed5f5f !important;
  color: #fff !important;
}

.btn-modal-accept {
  height: 50% !important;
  width: auto !important;
  background-color: #3085d6 !important;
  font-size: 12px !important;
}

.btn-modal-cancel {
  height: 50% !important;
  width: auto !important;
  background-color: #d33 !important;
  font-size: 12px !important;
}

.btn-modal-download {
  height: 50% !important;
  width: auto !important;
  background-color: #a4a8ab !important;
  font-size: 12px !important;
}

.style_BTN {
  width: 31.2px;
  object-fit: contain;
}

.modal-header {
  background-color: #67a3cf;
  margin-bottom: 20px;
  margin-top: -20px;
}
</style>
<style scoped>
.btn-Adjuntar {
  width: 10rem !important;
  height: 5rem !important;
  border-radius: 6px !important;
  border: solid 1px #1a8a68 !important;              /* Verde más claro y fresco */
  background-color: #28a187 !important;              /* Fondo más amigable */
  color: rgb(255, 255, 255) !important;                           /* Para mejor contraste */
  transition: background-color 0.3s ease, filter 0.3s ease;
}

.btn-Adjuntar:hover,
.btn-Adjuntar:active,
.btn-Adjuntar.clicked {
  background-color: #218f77 !important;              /* Un tono más oscuro al hacer hover */
  filter: brightness(95%);
  color: white !important;
}

.btn-file {
  overflow: hidden;
  position: relative;
}
.btn-file input[type="file"] {
  cursor: inherit;
  display: block;
  font-size: 100px;
  min-height: 100%;
  min-width: 100%;
  opacity: 0;
  position: absolute;
  right: 0;
  text-align: right;
  top: 0;
}

.previewImg {
  position: initial;
  z-index: 0;
}
</style>
